import http from "../../../lib/http/httpClient";
import { format } from "date-fns";

export const downloadShipmentInformationReport = async (fromDate?: Date, toDate?: Date, custId?: string): Promise<Blob> => {
  const queryParams = new URLSearchParams();

  if (fromDate) {
    queryParams.append("from", format(fromDate, "yyyy-MM-dd"));
  }

  if (toDate) {
    queryParams.append("to", format(toDate, "yyyy-MM-dd"));
  }

  if (custId) {
    queryParams.append("cust_id", custId);
  }

  return await http.get<Blob>(`/api/v1/cp/reports/shipment-report?${queryParams.toString()}`, { responseType: "blob" });
};

export const downloadShipmentMISReport = async (fromDate?: Date, toDate?: Date, custId?: string): Promise<Blob> => {
  const queryParams = new URLSearchParams();

  if (fromDate) {
    queryParams.append("from", format(fromDate, "yyyy-MM-dd"));
  }

  if (toDate) {
    queryParams.append("to", format(toDate, "yyyy-MM-dd"));
  }

  if (custId) {
    queryParams.append("cust_id", custId);
  }

  return await http.get<Blob>(`/api/v1/cp/reports/shipment-mis?${queryParams.toString()}`,{ responseType: "blob" });
};